<template>
  <mdb-card narrow>
    <mdb-view
      :hover="type !== context"
      cascade
      class="pb-1 pt-2"
      :gradient="gradient"
    >
      <a @click="clicked">
        <a v-if="!simple" class="mr-1" @click.stop="merge" style="position: relative; z-index: 10">
          <small><mdb-icon icon="project-diagram" title="Merge with another order"/></small>
        </a>
        <a v-if="!simple" class="mr-1" @click.stop="deleteOrder" style="position: relative; z-index: 10">
          <small><mdb-icon icon="trash" title="Delete order"/></small>
        </a>
        <a v-if="!simple" class="mr-1" @click.stop="editName" style="position: relative; z-index: 10">
          <small><mdb-icon icon="pencil-alt" title="Edit order name"/></small>
        </a>
        <span>{{ name }}</span>
        <small>({{ order[type].name }})</small>
        <mdb-mask v-if="type !== context" flex-center waves overlay="white-slight"></mdb-mask>
      </a>
    </mdb-view>
    <mdb-card-body cascade class="px-3 pb-2 entity-card-body">
      <ul class="list-unstyled">
        <li class="mb-1 d-flex justify-content-between">
          <mdb-icon icon="user" class="mr-2"/>{{ order.author }}
        </li>
        <li class="mb-1 d-flex justify-content-between">
          <mdb-icon icon="clock" class="mr-2"/><span :title="created.full">{{ created.date }}</span>
        </li>
      </ul>
    </mdb-card-body>
  </mdb-card>
</template>

<script>
import {
  mdbIcon,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbCardTitle,
  mdbView,
  mdbMask
} from 'mdbvue'
import {OrderTypes} from '../enums'
import {formatD, formatDT, errorCatch} from '../utils'
import {mapActions} from 'vuex'

export default {
  name: 'OrderOrder',
  props: {
    context: {
      validator: context => Object.values(OrderTypes).includes(context) || context === null
    },
    order: {
      type: Object,
      required: true
    },
    simple: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    type: function () {
      if (this.order.client) {
        return OrderTypes.CLIENT
      }
      if (this.order.agent) {
        return OrderTypes.AGENT
      }
      return null
    },
    gradient: function () {
      switch (this.type) {
        case OrderTypes.AGENT: return 'deep-blue'
        case OrderTypes.CLIENT: return 'aqua'
      }
    },
    name: function () {
      return this.order.info.name || `Order #${this.order.info.number}`
    },
    created: function () {
      return { full: formatDT(this.order.info.created), date: formatD(this.order.info.created) }
    }
  },
  methods: {
    ...mapActions(['apiOrderSetName', 'apiOrderDelete', 'apiOrdersMerge']),
    clicked () {
      if (this.type === this.context) return
      if (this.simple) {
        this.$router.push({name: 'order', params: { uuid: this.order.info.uuid }})
      } else {
        this.$bus.$emit(
          'modal-confirmation',
          {
            question: 'Are you sure to switch context?',
            callback: answer => {
              if (answer) {
                this.$router.push({name: 'order', params: { uuid: this.order.info.uuid }})
              }
            }
          }
        )
      }
    },
    merge () {
      this.$bus.$emit(
        'modal-order-select',
        {
          current: this.order.info.uuid,
          agent: this.order.client ? null : this.order.agent.name,
          client: this.order.client ? this.order.client.name : null,
          callback: uuid => {
            this.apiOrdersMerge({src: uuid, dest: this.order.info.uuid})
              .then(() => { this.$emit('selected') })
              .catch(errorCatch('Orders Merge failed!', this))
          }
        }
      )
    },
    editName () {
      this.$bus.$emit(
        'modal-textarea',
        {
          text: this.order.info.name,
          callback: text => {
            if (text !== this.order.info.name) {
              const data = {uuid: this.order.info.uuid, name: text || null}
              this.apiOrderSetName(data)
                .then(() => {
                  this.$bus.$emit('order-name-change', data)
                })
                .catch(errorCatch('Order Name Change failed', this))
            }
          }
        }
      )
    },
    deleteOrder () {
      this.$bus.$emit('modal-confirmation',
        {
          question: `Are you sure want to delete "${this.name}"`,
          callback: answer => {
            if (answer) {
              this.apiOrderDelete(this.order.info.uuid)
                .then(this.$emit('deleted'))
                .catch(errorCatch('Order Delete failed!', this))
            }
          }
        }
      )
    }
  },
  components: {
    mdbIcon,
    mdbCard,
    mdbCardBody,
    mdbCardHeader,
    mdbCardTitle,
    mdbView,
    mdbMask
  }
}
</script>

<style lang="sass" scoped>
.entity-card-body
  font-size: 75%
</style>



// WEBPACK FOOTER //
// src/components/OrderOrder.vue